<script>
  import loginServico from './servico';
  import radio from '~componentes/Radio.vue';

  export default {
    components: { radio },
    data() {
      return {
        usuario: {},
        tipoDocumento: 'CPF',
        mostrarErroUsuario: false, 
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar: function () {
        this.$validator.validateAll();

        if (!this.errors.any()) {
          this.login()
        }
      },
      login: function () {
        this.mostrarErroUsuario = false;
        
        $('.btn').button('loading');

        loginServico.importacao(this.usuario)
          .then(resposta => {
            this.$storage.usuario(resposta.body.usuario);
            this.$storage.token(resposta.body.token);
          })
          .then(() => {
            this.$router.push('/');
          })
          .catch(erro => {
            $('.btn').button('reset');
            
            if (erro.status === 404) {
              this.mostrarErroUsuario = true;
            } else if (erro.status === 401) {
              this.$swal('', erro.body.message, 'warning');
            } else {
              this.$swal('', 'Ocorreu um erro no login, caso o erro persista entre em contato com a fundação.', 'error');
            }
            this.$router.push('/login/importacao');
          });
      },
      limparDocumento() {
        this.usuario.login = '';
      }
    },
    mounted() {
    },
    watch: {
      'tipoDocumento': 'limparDocumento',
    }
  }
</script>

<template>
  <div>
    <form class="m-t" role="form" @submit.prevent="validar">
      <div class="alert alert-danger" role="alert" v-show="mostrarErroUsuario">{{ tipoDocumento }} ou senha incorreto(s).</div>
      
      <div class="form-froup margin-bottom-10">
        <radio v-model="tipoDocumento"
               selected-value="CPF"
               type="primary"
               text-class="text-white"
               :inline="true"
               class="margin-right-10">
          Pessoa Física
        </radio>
        <radio v-model="tipoDocumento"
               selected-value="CNPJ"
               type="primary"
               :inline="true"
               text-class="text-white">
          Pessoa Jurídica
        </radio>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('documento') }">
        <input 
            type="text" 
            class="form-control" 
            :placeholder="tipoDocumento" 
            name="documento" 
            id="documento"
            v-model="usuario.login"
            v-validate="`required|${tipoDocumento.toLocaleLowerCase()}`"
            v-mascara="tipoDocumento.toLocaleLowerCase()">

          <p class="text-danger" v-if="errors.has('documento')">{{ errors.first('documento') }}</p>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('senha') }">
        <input 
            type="password" 
            class="form-control" 
            placeholder="*******" 
            name="senha" 
            v-model="usuario.senha" 
            v-validate="'required'">
               
          <p class="text-danger" v-if="errors.has('senha')">{{ errors.first('senha') }}</p>
      </div>
      <button 
          type="submit" 
          class="btn btn-primary block full-width m-b" 
          data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Entrando...">
        Entrar
      </button>

      <router-link :to="{ name: 'recuperarsenha', params: { importacao: true } }" class="text-info">
        <i class="fa fa-lock"></i> RECUPERAR SENHA
      </router-link>
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/login/LoginImportacao.vue